import { EmploymentType } from '../../../Types/Portfolio/EmploymentType';

export const KidiUp: EmploymentType = {
	company: 'KidiUp',
	position: 'Founder & CTO',
	objective: "A platform to find, book, pay and keep track of children's activities all in one place.",
	logo: 'https://assets.dear-ux.com/faizhirani/images/logos/KidiUp.png',
};
